//@flow
import React from "react"
import styled from "styled-components"
import SVGLoader from "../../UI/SVGLoader"

const PrimaryOptionContainer = styled.div`
  border-radius: 1rem;
  background: #25beae${props => (props.disabled ? "99" : "ff")};
  height: 293px;
  width: 293px;
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  padding: 0 12px 8px 12px;
  margin: auto;
  opacity: 
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  & > * {
    opacity: ${props => (props.disabled ? 0.5 : 1)};
  }
`

const Line = styled.span`
  display: block;
  margin: 0 auto;
  text-align: center;
`

const PrimaryOptionIconContainer = styled.div`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  position: relative;

  & > * {
    position: absolute;
    top: 0;
    left: 0;
  }
`

const PrimaryOptionIcon = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  position: relative;

  & > * {
    margin: auto;
  }
`

const PrimaryOptionText = styled.div`
  color: #121f48;
  font-family: "din-condensed";
  font-weight: 400;
  font-size: 27px;
  min-height: 72px;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  flex-align: center;
`

const PrimaryOptionList = styled.div`
  display: flex;
  flex-direction: row;
  padding: 18px 0;
  justify-content: space-between;
`

type Props = {
  path: string,
  title: string[],
  height: string,
  width: string,
  destination: string,
  disabled?: boolean,
  modal?: boolean,
  innerRef?: (el: HTMLElement) => any,
  onSelect?: (path: string, modal: ?boolean) => any
}

class PrimaryOption extends React.Component<Props> {
  handleClick = () => {
    const { onSelect, destination, modal } = this.props
    if (onSelect) {
      onSelect(destination, modal)
    }
  }

  render() {
    const { path, title, height, width, disabled, innerRef } = this.props
    return (
      <PrimaryOptionContainer
        innerRef={innerRef}
        onClick={this.handleClick}
        disabled={disabled}
      >
        <PrimaryOptionIcon>
          <PrimaryOptionIconContainer height={height} width={width}>
            <SVGLoader path={path} height="100%" width="100%" fill="#132048" />
          </PrimaryOptionIconContainer>
        </PrimaryOptionIcon>
        <PrimaryOptionText>
          {title.map(t => <Line key={t}>{t}</Line>)}
        </PrimaryOptionText>
      </PrimaryOptionContainer>
    )
  }
}

export { PrimaryOptionList }

export default PrimaryOption



// WEBPACK FOOTER //
// ./src/Kiosk/AttractLoopView/PrimaryOption.js